// @bend-expect quartz-no-already-provided-providers
import { Router } from '../react-router';
import { HistoryBasePathContext } from './routingContexts';
import { getHistoryBasePath } from '../service';
import { jsx as _jsx } from "react/jsx-runtime";
export { SearchParamsContext, PathnameContext, HistoryContext, HistoryBasePathContext } from './routingContexts';
/**
 * RouterProvider provides Quartz-specific routing context to the application.
 *
 * The history / pathname / search-params contexts are mounted by `<Router>`
 * itself, so those hooks work anywhere a router is rendered. RouterProvider
 * layers on the one Quartz-app-only context: `HistoryBasePathContext`, which is
 * derived from the configured `historyBasename` and therefore only available in
 * Quartz apps.
 */
export function RouterProvider({
  children,
  history
}) {
  return /*#__PURE__*/_jsx(Router, {
    history: history,
    children: /*#__PURE__*/_jsx(HistoryBasePathContext.Provider, {
      value: getHistoryBasePath(),
      children: children
    })
  });
}